import { registerPlugin } from '@capacitor/core';

interface DurableStoragePlugin {
  set(options: { key: string; value: string }): Promise<void>;
  get(options: { key: string }): Promise<{ value: string | null }>;
  remove(options: { key: string }): Promise<void>;
}

export const DurableStorage =
  registerPlugin<DurableStoragePlugin>('DurableStorage');
